<template>
    <div class="field-store-status" v-html="status"></div>
</template>

<script>
import { buildStatus } from '@/services/StoreStatus.js'
import ServiceDrupal from '@/services/ServiceDrupal.js'
import StoreService from '@/services/StoreService.js'

export default {
    name: 'store-status',
    data () {
        return {
            status: `<div class='loading-status mb-1'></div>`,
            store: {}
        }
    },
    methods: {},
    beforeMount () {
        if(!this.$options.parent.id) {
            this.store = ServiceDrupal.getStore()
        }
    },
    mounted () {
        if(Object.keys(this.store).length===0) {
            StoreService.getStoreByID(this.$options.parent.id)
                .then(response => {
                    if(response.data.length == 1)
                        {
                            let element = response.data[0]
                            let data = {
                                opening_hours: JSON.parse(element.opening_hours),
                                lunch_break: JSON.parse(element.lunch_break),
                                federal_state: element.federal_state,
                                special_hours: JSON.parse(element.special_bushours)
                            }
                            this.status = buildStatus(data, 'l')

                        }
                 })
        }
        else{
            StoreService.getStoreByID(this.store.id)
                .then(response => {
                    if(response.data.length == 1){
                        let element = response.data[0]
                        let data = {
                            opening_hours: JSON.parse(element.opening_hours),
                            lunch_break: JSON.parse(element.lunch_break),
                            federal_state: element.federal_state,
                            special_hours: JSON.parse(element.special_bushours)
                        }
                        this.status = buildStatus(data, 'l')
                    }
                })
        }
    }
}
</script>
